import { NotificationBanner } from 'nhsuk-react-components';
import { Link } from 'react-router-dom';
import useNotifications from 'queries/fetch/useNotifications.ts';

function ActivityBanner() {
  const { data: notifications } = useNotifications();
  const unreadCount = notifications?.filter((notification) => !notification.read).length ?? 0;

  if (unreadCount === 0) {
    return null;
  }

  return (
    <NotificationBanner title="Activity" style={{ marginBottom: '48px' }}>
      <NotificationBanner.Heading>
        {`You have ${unreadCount} new notification${unreadCount === 1 ? '' : 's'}`}
      </NotificationBanner.Heading>
      <NotificationBanner.Link asElement={Link} to="/activity">
        View all activity
      </NotificationBanner.Link>
    </NotificationBanner>
  );
}

export default ActivityBanner;
